// extracted by mini-css-extract-plugin
export var active = "_ga-2";
export var recordingDot = "_ga-1";
export var recordingIndicator = "_ga-0";